import React from "react";
import "./Navbar222.css";
import { useNavigate } from "react-router-dom";

export const Navbar22 = () => {
    const navigate = useNavigate(); // хук для переходов

    const goToProfile = () => {
        navigate("/profile-page");
    };

    const goToHome = () => {
        navigate("/");
    };

    return (
        <div className="navbar2-container2">
            <img
                className="logo2"
                alt="Logo"
                src="https://c.animaapp.com/mdgpppf7nmySsB/img/----------2.png"
                onClick={goToHome}
                style={{ cursor: "pointer" }} // чтобы курсор был как на кнопке
            />

            <div className="info-section2">
                <div className="text-wrapper-282">+998 55 515-65-65</div>
                <div className="FLAG2">
                    <div className="rectangle-42" />
                    <div className="rectangle-52" />
                    <div className="rectangle-62" />
                </div>
                <div className="text-wrapper-292">RU</div>

                <div
                    className="text-wrapper-302"
                    onClick={goToProfile}
                    style={{ cursor: "pointer" }}
                >
                    ЛИЧНЫЙ КАБИНЕТ
                </div>            </div>
        </div>
    );
};
